(function () {
  'use strict';

  let angular = window.angular;

  DeviceConfigurationController.$inject = [
    '$rootScope',
    'Customer',
    'Device',
    'EdgeDeviceService',
    '$timeout',
    '$state',
    '$uibModal',
    'assetUtilsService',
    'AppUtils',
  ];

  angular.module('app').component('connectionDevice', {
    template:'<view-sidebar><view-sidebar-title><span translate>entities.device.modelName</span><div class="btn-group btn-group-sm pull-right"><a class="btn btn-primary" title="{{:: \'buttons.new\' | translate}} {{:: \'entities.device.modelName\' | translate}}" ng-click="ctrl.showDeviceForm(null, null)"><i class="fas fa-plus"></i></a> <a class="btn btn-primary btn-sm" ng-class="{disabled: !ctrl.deviceId}" ui-sref=".({deviceId: null})"><i class="fas fa-ban"></i></a></div></view-sidebar-title><view-sidebar-content><js-tree data="ctrl.devicesTree" selected="ctrl.deviceId" tree-instance="ctrl.treeInstance" on-ready="ctrl.onTreeReady()" on-select="ctrl.onSelectDevice(selected)"></js-tree><div class="absolute" ng-if="ctrl.loading"></div></view-sidebar-content></view-sidebar><div><view-sidebar-toggle></view-sidebar-toggle><div ng-hide="ctrl.deviceSelected || ctrl.loading"><h1 class="centered-message no-margin"><i class="fas fa-arrow-circle-left"></i> <span translate>general._select.an</span> <span translate>entities.device.modelName</span></h1></div><div ng-if="ctrl.deviceSelected" ng-show="!ctrl.loading"><div class="asset-profile"><div class="padding20"><div class="asset-name"><div><h2 title="{{ctrl.deviceSelected.name}}">{{ctrl.deviceSelected.name}}</h2><div class="btn-group"><button class="btn btn-info btn-sm" ng-click="ctrl.showDeviceLogs()" title="Logs" ng-if="ctrl.features.logs"><span style="font-size: 4px; vertical-align: inherit"><span class="fa-stack fa-2x"><i class="fas fa-file fa-stack-2x"></i> <i class="fas fa-search fa-stack-1x text-info" style="margin-top: 3px; margin-left: 1px"></i></span></span></button><div class="btn-group pull-right" style="float: left !important" uib-dropdown><button type="button" class="btn btn-sm btn-default" uib-dropdown-toggle><i class="fas fa-fw fa-cogs"></i></button><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li><a class="cursor-pointer" ng-click="ctrl.confirmRestart()" translate>entities.device._commands.restart</a></li><li><a class="cursor-pointer" ng-click="ctrl.confirmRestartModule()" translate>entities.device._commands.restartModule</a></li></ul></div><a class="btn btn-primary btn-sm" ng-click="ctrl.showDeviceForm(ctrl.deviceSelected)"><i class="fas fa-edit"></i></a> <a class="btn btn-danger btn-sm" ng-click="ctrl.confirmRemoveDevice(ctrl.deviceSelected)"><i class="fas fa-trash"></i></a></div><div class="clearfix"></div></div><div ng-if="ctrl.deviceSelected.status" class="marginB5"><small title="{{ctrl.deviceSelected.requested | date: \'dd-MM-yyyy HH:mm\'}}" class="label label-{{ctrl.deviceSelected.status}}" style="font-size: 9px; vertical-align: middle"><i class="fa fa-circle"></i> <span translate>{{\'general._status.\' + ctrl.deviceSelected.status}}</span></small></div></div><table class="table no-margin table-description"><thead><tr><th colspan="4" class="no-padding"></th></tr></thead><tbody><tr class="bordered"><td class="field">Id</td><td class="clipboard" style="cursor: copy" clipboard data-text="ctrl.deviceSelected.id">{{ctrl.deviceSelected.id}} <button class="btn btn-default btn-sm btn-clipboard" title="Copy to clipboard"><i class="fas fa-copy"></i></button></td><td class="field" translate>entities._all.enabled</td><td><span class="label" translate ng-class="{\'label-success\': ctrl.deviceSelected.enabled, \'label-default\': !ctrl.deviceSelected.enabled}">{{ctrl.deviceSelected.enabled ? \'entities._all.enabled\' : \'entities._all.disabled\'}}</span></td></tr><tr ng-if="ctrl.deviceSelected.version || ctrl.deviceSelected.uptime"><td class="field" translate ng-if="ctrl.deviceSelected.version">entities.device.version</td><td ng-if="ctrl.deviceSelected.version">{{ctrl.deviceSelected.version.content.v}}</td><td class="field" translate ng-if="ctrl.deviceSelected.uptime">entities.device.started</td><td ng-if="ctrl.deviceSelected.uptime">{{ctrl.deviceSelected.uptime.started | date: \'dd-MM-yyyy HH:mm\'}}</td></tr><tr><td class="field" translate>entities._all.description</td><td colspan="3" data-label="Description" class="block"><div class="asset-description" data-label="{{:: \'buttons.expand\' | translate}}" ng-class="{\'opened\': ctrl.showDescription, \'gradient\': ctrl.deviceSelected.description}" ng-click="ctrl.showDescription = true"><div id="deviceDescription" class="markdown" markdown-to-html="ctrl.deviceSelected.description || \'\'"></div></div><div ng-if="ctrl.showDescription" style="text-align: center" class="asset-description"><a class="contraction-text" ng-click="ctrl.showDescription=false" translate>buttons.hide</a></div></td></tr></tbody></table></div></div><div class="panel panel-default"><div class="panel-heading"><ul class="nav nav-tabs"><li ng-class="{active: ctrl.agentMode === \'default\'}"><a class="cursor-pointer" ng-click="ctrl.agentMode = \'default\'" translate>entities.edgeagent.modelNamePl</a></li><li ng-class="{active: ctrl.agentMode === \'module\'}"><a class="cursor-pointer" ng-click="ctrl.agentMode = \'module\'" translate>entities.device.module.modelNamePl</a></li><li ng-class="{active: ctrl.agentMode === \'config\'}"><a class="cursor-pointer" ng-click="ctrl.agentMode = \'config\'" translate>entities.device.config</a></li></ul></div><div class="paddingT5"><device-edge-agent-table device="ctrl.deviceSelected" assets="ctrl.assets" projects="ctrl.projects" ng-if="ctrl.agentMode === \'default\'"></device-edge-agent-table><device-modules-table device="ctrl.deviceSelected" ng-if="ctrl.agentMode === \'module\'" logs="ctrl.features.logs"></device-modules-table><device-config-view ng-if="ctrl.agentMode === \'config\'" is-admin="ctrl.isAdmin" device="ctrl.deviceSelected"></device-config-view></div></div><div class="panel panel-default"><div class="panel-heading" translate>entities.telegramchat.modelNamePl</div><div class="paddingT5"><telegram-chat-table entity="ctrl.Device" instance="ctrl.deviceSelected"></telegram-chat-table></div></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner></div>',
    controller: DeviceConfigurationController,
    controllerAs: 'ctrl',
    bindings: {
      $transition$: '<',
      devices: '<',
      customer: '<',
      projects: '<',
      assets: '<',
      isAdmin: '<',
    },
  });

  function DeviceConfigurationController(
    $rootScope,
    Customer,
    Device,
    EdgeDeviceService,
    $timeout,
    $state,
    $uibModal,
    assetUtilsService,
    appUtils
  ) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.onSelectDevice = onSelectDevice;
      vm.Device = Device;
      vm.assets = vm.assets.assets;

      vm.treeInstance = {};
      vm.devicesTree = vm.devices.tree;
      vm.devices = appUtils.arrayToObject(vm.devices.devices, 'id');
      vm.agentMode = 'default';

      // modals
      vm.showDeviceForm = showDeviceForm;
      vm.confirmRemoveDevice = confirmRemoveDevice;
      vm.showDeviceLogs = showDeviceLogs;
      vm.deviceSelected = null;

      vm.confirmRestart = confirmRestart;
      vm.confirmRestartModule = confirmRestartModule;

      vm.onTreeReady = onTreeReady;

      checkIdParam(vm.$transition$.params().deviceId);

      vm.uiOnParamsChanged = function (params) {
        if (params.deviceId !== undefined) {
          checkIdParam(params.deviceId);
        }
      };
    };

    function onTreeReady() {
      loadUptimes();
    }

    function loadUptimes() {
      EdgeDeviceService.getUptimes(Object.keys(vm.devices)).then((uptimes) => {
        const treeInstance = vm.treeInstance.instance;
        uptimes.successful.forEach((current) => {
          vm.devices[current.id].uptime = current;
          vm.devices[current.id].status = 'online';
          if (treeInstance && treeInstance._model) {
            treeInstance._model.data[current.id].li_attr['data-status'] = 'online';
            document.getElementById(current.id).dataset.status = 'online';
          }
        });
      });
    }

    function showDeviceForm(device) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        keyboard: false,
        component: 'connectionDeviceForm',
        resolve: {
          device: device,
          customer: vm.customer,
        },
      });

      instance.result
        .then(function (result) {
          if (result.operation === 'create') {
            $state.go('.', { deviceId: result.device.id }, { reload: true });
          } else if (result.operation === 'update') {
            if (device.name !== result.device.name) {
              $rootScope.$broadcast('jstree.rename-node', result.node);
            }

            if (device.icon !== result.device.icon) {
              $rootScope.$broadcast('jstree.icon-node', result.node);
            }

            onSelectDevice(result.device.id);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function onSelectDevice(selected) {
      if (!selected) {
        vm.deviceSelected = null;
        return;
      }
      $state.go('.', { deviceId: selected });

      vm.loading = true;
      let device;
      Customer.devices({
        id: vm.customer.id,
        filter: {
          where: { id: selected },
          include: ['telegramChats'],
        },
      })
        .$promise.then(function (result) {
          device = result[0];
          return EdgeDeviceService.loadEdgeAgents(device.customerId, device.id);
        })
        .then((edgeAgents) => {
          device.edgeAgents = edgeAgents;
          device.status = 'undefined';
          vm.deviceSelected = device;
          vm.loading = false;
          return EdgeDeviceService.getVersions([device.id]);
        })
        .then((versions) => {
          device.version = versions.successful[0];
          vm.features = {
            logs:
              appUtils.semverCompare(device.version ? device.version.content.v : '', '1.0.0') >= 0,
          };
          return EdgeDeviceService.getUptimes([device.id]);
        })
        .then((uptime) => {
          device.uptime = uptime.successful[0];
          device.status = assetUtilsService.getStatus(device);
          if (device.uptime) {
            device.status = 'online';
            device.requested = new Date();
          }
        })
        .catch(function (err) {
          console.log(err);
          vm.loading = false;
        });
    }

    function confirmRemoveDevice(device) {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        windowClass: 'modal-xs modal-warning',
        bindToController: true,
        keyboard: false,
        component: 'connectionDeviceRemove',
        resolve: {
          device: device,
          customer: vm.customer,
        },
      });

      instance.result
        .then(function () {
          $state.go('.', { deviceId: null }, { reload: true });
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function checkIdParam(deviceIdParam) {
      if (deviceIdParam) {
        if (vm.devices[deviceIdParam]) {
          vm.deviceId = deviceIdParam;
        } else {
          $state.go('.', { deviceId: null });
        }
      } else {
        vm.deviceId = null;
      }
    }

    function showDeviceLogs() {
      $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          windowClass: 'modal-full',
          bindToController: true,
          component: 'connectionDeviceLogs',
          resolve: {
            device: vm.deviceSelected,
          },
        })
        .result.catch((err) => {});
    }

    function confirmRestart() {
      $uibModal
        .open({
          animation: false,
          bindToController: true,
          backdrop: 'static',
          windowClass: 'modal-xs modal-warning',
          component: 'connectionDeviceCommands',
          resolve: {
            device: () => vm.deviceSelected,
            command: () => 'restart',
          },
        })
        .result.catch((err) => {
          console.log(err);
        });
    }

    function confirmRestartModule() {
      $uibModal
        .open({
          animation: false,
          bindToController: true,
          backdrop: 'static',
          windowClass: 'modal-xs modal-warning',
          component: 'connectionDeviceModuleCommands',
          resolve: {
            device: () => vm.deviceSelected,
            command: () => 'restart',
          },
        })
        .result.catch((err) => {
          console.log(err);
        });
    }
  }
})();
